import type { AnalyticsEvent, LogEvent, TelemetryEvent } from '../events';

import { emitToLegacy, emitToLegacyNow } from './eventSink';

export type ReportTelemetryEvent = (event: TelemetryEvent) => Promise<void>;
export const reportTelemetryEvent: ReportTelemetryEvent = emitToLegacy;

export type ReportTelemetryEventNow = (event: AnalyticsEvent | LogEvent) => Promise<void>;
export const reportTelemetryEventNow: ReportTelemetryEventNow = emitToLegacyNow;
